import { IMarketingEventsDepartmentsDTO, IMarketingEventsDepartmentsViewDTO, IMarketingEventsDistributorsDTO, IMarketingEventsDistributorsViewDTO, IMarketingEventsDTO, IMarketingEventsFactDepartmentsDTO, IMarketingEventsFactDepartmentsViewDTO, IMarketingEventsPlanDepartmentsDTO, IMarketingEventsPlanDepartmentsViewDTO, IMarketingEventsProductsDTO, IMarketingEventsProductsViewDTO, IMarketingEventsViewDTO } from "../../coreapi-dto/dirs/marketingEvents";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface IMarketingEventsCreate extends IMarketingEventsDTO {
}
interface IMarketingEventsUpdate extends IMarketingEventsDTO {
}

interface IMarketingEventsProductsCreate extends IMarketingEventsProductsDTO {
}
interface IMarketingEventsProductsUpdate extends IMarketingEventsProductsDTO {
}

interface IMarketingEventsPlanDepartmentsCreate extends IMarketingEventsPlanDepartmentsDTO {
}
interface IMarketingEventsPlanDepartmentsUpdate extends IMarketingEventsPlanDepartmentsDTO {
}

interface IMarketingEventsFactDepartmentsCreate extends IMarketingEventsFactDepartmentsDTO {
}
interface IMarketingEventsFactDepartmentsUpdate extends IMarketingEventsFactDepartmentsDTO {
}

interface IMarketingEventsDistributorsCreate extends IMarketingEventsDistributorsDTO {
}
interface IMarketingEventsDistributorsUpdate extends IMarketingEventsDistributorsDTO {
}

interface IMarketingEventsDepartmentsCreate extends IMarketingEventsDepartmentsDTO {
}
interface IMarketingEventsDepartmentsUpdate extends IMarketingEventsDepartmentsDTO {
}

class MarketingEventsRequest extends BaseDirRequest<IMarketingEventsViewDTO, IMarketingEventsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEvent", token, eventHandler)
    }
    
    create(body: IMarketingEventsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    getViewParam (body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IMarketingEventsViewDTO>>) => void, report?: (value) => void) {
            this.post<IViewWrapper<IMarketingEventsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewParam`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    } else {
                        callback?.(e);
                        report?.({ name: `${this._routePrefix}/view`, time: e.time })
                    }
                }
    
    
            })
        }
}

class MarketingEventsProductsRequest extends BaseDirRequest<IMarketingEventsProductsViewDTO, IMarketingEventsProductsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEventProduct", token, eventHandler)
    }
    
    create(body: IMarketingEventsProductsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsProductsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}

class MarketingEventsPlanDepartmentsRequest extends BaseDirRequest<IMarketingEventsPlanDepartmentsViewDTO, IMarketingEventsPlanDepartmentsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEventPlanDepartment", token, eventHandler)
    }
    
    create(body: IMarketingEventsPlanDepartmentsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsPlanDepartmentsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}

class MarketingEventsFactDepartmentsRequest extends BaseDirRequest<IMarketingEventsFactDepartmentsViewDTO, IMarketingEventsFactDepartmentsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEventFactDepartment", token, eventHandler)
    }
    
    create(body: IMarketingEventsFactDepartmentsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsFactDepartmentsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}

class MarketingEventsDistributorsRequest extends BaseDirRequest<IMarketingEventsDistributorsViewDTO, IMarketingEventsDistributorsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEventDistributor", token, eventHandler)
    }
    
    create(body: IMarketingEventsDistributorsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsDistributorsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}

class MarketingEventsDepartmentsRequest extends BaseDirRequest<IMarketingEventsDepartmentsViewDTO, IMarketingEventsDepartmentsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingEventDepartment", token, eventHandler)
    }
    
    create(body: IMarketingEventsDepartmentsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingEventsDepartmentsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}

export {
    MarketingEventsRequest,
    MarketingEventsProductsRequest,
    MarketingEventsPlanDepartmentsRequest,
    MarketingEventsFactDepartmentsRequest,
    MarketingEventsDistributorsRequest,
    MarketingEventsDepartmentsRequest
};